import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const services = [
    'LPG Remote Valve Control',
    'Industrial Automation',
    'IIoT Solutions',
    'Energy Monitoring System',
    'Water Monitoring System',
    'Pump House Automation',
  ];

  const quickLinks = [
    { name: 'Home', path: '/' },
    { name: 'About Us', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Projects', path: '/projects' },
    { name: 'Events Gallery', path: '/events' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <footer className="bg-slate-900 text-slate-300" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_usha-control/artifacts/ugawy9rv_Screenshot%202026-02-17%20122401.png" 
              alt="Usha Automation" 
              className="h-12 w-auto mb-6"
              data-testid="footer-logo"
            />
            <p className="text-sm leading-relaxed mb-6">
              Engineering reliable, scalable, and compliance-driven control systems for modern industries.
            </p>
            <p className="text-sm font-semibold text-slate-100 mb-2">5+ Years of Industry Experience</p>
          </div>

          <div>
            <h3 className="text-white font-semibold text-lg mb-6" data-testid="footer-quick-links-heading">Quick Links</h3>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-sm hover:text-[#FF7F2A] transition-colors duration-300"
                    data-testid={`footer-link-${link.name.toLowerCase().replace(' ', '-')}`}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold text-lg mb-6" data-testid="footer-services-heading">Our Services</h3>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service}>
                  <span className="text-sm">{service}</span>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold text-lg mb-6" data-testid="footer-contact-heading">Contact Info</h3>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <Phone className="w-5 h-5 mt-0.5 flex-shrink-0 text-[#FF7F2A]" />
                <div>
                  <p className="text-sm font-medium text-slate-100">Mr. Shantanu</p>
                  <a href="tel:+919953804787" className="text-sm hover:text-[#FF7F2A] transition-colors" data-testid="footer-phone">
                    +91 9953804787
                  </a>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <Mail className="w-5 h-5 mt-0.5 flex-shrink-0 text-[#FF7F2A]" />
                <a href="mailto:Support@ushaautomationiiot.in" className="text-sm hover:text-[#FF7F2A] transition-colors" data-testid="footer-email">
                  Support@ushaautomationiiot.in
                </a>
              </div>
              <div className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 mt-0.5 flex-shrink-0 text-[#FF7F2A]" />
                <div>
                  <p className="text-sm font-semibold text-slate-100 mb-1">Corporate Office</p>
                  <address className="text-sm not-italic leading-relaxed" data-testid="footer-address-corporate">
                    Plot No. 497, 3rd Floor<br />
                    Bharthal, Sector-26, Dwarka<br />
                    New Delhi – 110077<br />
                    India
                  </address>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 mt-0.5 flex-shrink-0 text-[#FF7F2A]" />
                <div>
                  <p className="text-sm font-semibold text-slate-100 mb-1">Workshop</p>
                  <address className="text-sm not-italic leading-relaxed" data-testid="footer-address-workshop">
                    WZ-502, Sadh Nagar<br />
                    Street 17-B, Palam<br />
                    New Delhi – 110045<br />
                    India
                  </address>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-12 pt-8 text-center">
          <p className="text-sm">
            © 2026 Usha Automation. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
